import { v4 as uuidv4 } from "uuid";

import { safeGet, safeSet } from "./safeStorage";

const STORAGE_KEY = "voltaroute.device_id";

export function getDeviceId(): string {
  let id = safeGet(STORAGE_KEY);
  if (!id) {
    id = uuidv4();
    safeSet(STORAGE_KEY, id);
  }
  return id;
}
